import { createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b29ac6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      ($props.shouldShowTooltip)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["tooltip-box", [$props.position]])
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "x-button",
              src: require('@/assets/icons/x-icon.svg'),
              alt: "close",
              onClick: $setup.onClickCloseTooltip
            }, null, 8 /* PROPS */, ["src"]),
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "content", {}, undefined, true)
            ])
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }))
}